import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "@fontsource/mulish"; // Defaults to weight 400.

import Snackbar from '@mui/material/Snackbar';



const useStyles = makeStyles(theme => ({   
    outerRow: {        
        fontFamily:'Mulish', 
        fontWeight: '200',
        backgroundColor: '#F3F3F3',
        display:'flex',
        flexDirection: 'row',
        justifyContent:'flex-start',
        alignItems: 'center',
        flexBasis: 110, 
        flexGrow: 1,
        minWidth: 110,
        
        padding: '.5em', 
        margin: '.5em'
        
        
    }, 
    iconRow: {
        width:'15px'
    },
    rightColumn: {
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start',
        marginLeft: '1em', 
        
        fontSize: 13,
        fontWeight: 'bold',         
         wordBreak: 'break-word',

        
    },
    innerTopRow: {
        fontSize: 8,
        marginBottom: '.5em'
    },
    truncatedText: {
        width: '75px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }


    }));




const FavouriteDataItem = (props) => { 
    const classes = useStyles();

    
    const [showSnackbar, setShowSnackbar] = useState(false);

    const handleClick = async (value) => {
    
        navigator.clipboard.writeText(value).then(
            function() {
            setShowSnackbar(true);
        }, function() {
            console.log('copy failed');
        });        
    }
   

    return(
        <div className={classes.outerRow}>
           <div className ={classes.iconRow}>
           <FontAwesomeIcon icon={props.icon} />
           </div>

           <div className={classes.rightColumn} onClick={_=>handleClick(props.value+'')}>
                <div className={classes.innerTopRow}>
                    {props.title}
                </div>
                <div className={classes.truncatedText}>
                    {props.value+''} {/* concatenation to display boolean values */}
                </div>
           </div>

           <Snackbar
            open={showSnackbar}
            autoHideDuration={2000}
            onClose={_=>setShowSnackbar(false)}
            message="Verdien er kopiert"
            />
        </div>

        
    )
};

export default FavouriteDataItem;